import axios from 'axios'
import { Message } from 'element-ui'
import router from '../router/index'
import { debounce } from 'lodash'

// 配置环境变量
const baseURL = process.env.NODE_ENV === 'production' ? 'https://xunjiah.mkaka.icu' : ''
axios.defaults.baseURL = baseURL

// 防抖版本的系统状态检查函数
const checkSystemStatus = async function () {
  try {
    const response = await axios.get('/api/index/check')
    console.log(response, 'responseresponseresponse----->')
    if (response.data.data == 0) {
      // 系统不可用，跳转到维护页面
      Message.error('系统维护中，请稍后再试')
      router.push({ path: '/access_forbidden' }) // 替换为您要跳转的页面路径
      return false
    }
    return true
  } catch (error) {
    console.error('系统状态检查失败:', error)
    return true // 默认允许访问，避免因检查失败而阻断系统
  }
} // 防抖时间为 2000 毫秒（2秒）

// 请求拦截器
let checkSystemDebounced = null // 用于缓存防抖函数实例

axios.interceptors.request.use(
  async config => {
    // 排除系统状态检查接口本身，避免循环调用
    if (config.url !== '/api/index/check') {
      if (!checkSystemDebounced) {
        // 初始化防抖函数，只会在第一次请求时创建
        checkSystemDebounced = debounce(async () => {
          const isSystemAvailable = await checkSystemStatus()
          if (!isSystemAvailable) {
            // 中止当前请求
            return Promise.reject(new Error('系统维护中'))
          }
        }, 2000)
      }

      // 调用防抖函数并等待其执行
      let data = await checkSystemDebounced()
    }

    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
axios.interceptors.response.use(
  response => {
    if (
      response.data.msg == '非法请求' ||
      response.data.msg == 'token已过期' ||
      response.data.code == 401 ||
      response.data.msg == '签名错误'
    ) {
      Message.error('未授权，跳转到登录页面')
      localStorage.removeItem('token')
      localStorage.removeItem('user_info')
      setTimeout(() => {
        router.push({ path: '/login' })
      }, 1500)
    }
    return response
  },
  error => {
    const { response } = error
    if (response) {
      const { status } = response
      if (status === 401) {
        Message.error('未授权，跳转到登录页面')
        router.push({ path: '/login' })
      } else if (status === 404) {
        Message.error('请求未找到')
      } else {
        // Message.error(response.data.message || '发生错误')
        console.log(response.data.message || '发生错误', '----->')
      }
    } else {
      // Message.error('网络错误，请稍后再试')
    }
    return Promise.reject(error)
  }
)

export default {
  axios,
  baseURL
}
